<template>
  <div class="wrap product_tab_1">
    <div class="search-wrap">
      <el-tabs value="first" class="product_management_box">
        <el-tab-pane label="查询条件" name="first">
          <div class="pulldownbox info-container" v-show="!showQueryFilter">
            <i class="el-icon-info"></i>
            <span>查询条件</span>
            <span class="pulldownbtn" @click="pulldown"
              >展开<i class="el-icon-arrow-down"></i
            ></span>
          </div>
          <!--展开内容-->
          <div
            style="width: 100%"
            class="expandbox info-container"
            v-show="showQueryFilter"
          >
            <el-form
              class="product_filter_form"
              :model="filterForm"
              inline
              ref="filterForm"
              size="small"
            >
              <el-form-item label="发布标题:" prop="pjInformationId" label-width="75px">
                <el-select
                  v-model="filterForm.pjInformationId"
                  placeholder="请选择发布标题"
                  ref="titleRef"
                  @change="titleChange"
                  class="textInput"
                  filterable
                >
                  <el-option
                    v-for="item in titleList"
                    :key="item.id"
                    :label="item.titile"
                    :value="item.id"
                  ></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="项目名称:" prop="pjConfigId" label-width="75px">
                <el-select
                  v-model="filterForm.pjConfigId"
                  placeholder="请选择项目名称"
                  class="textInput"
                  filterable
                >
                  <el-option
                    v-for="item in pjConfigList"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id"
                  ></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="项目截止时间:" prop="time" label-width="100px">
                <el-date-picker
                  v-model="filterForm.startTime"
                  type="date"
                  value-format="yyyy-MM-dd"
                  placeholder="选择开始时间">
                </el-date-picker>
                <el-date-picker
                  v-model="filterForm.endTime"
                  type="date"
                  value-format="yyyy-MM-dd"
                  placeholder="选择结束时间">
                </el-date-picker>
              </el-form-item>
            </el-form>
            <el-row style="text-align: center; margin: 5px 0">
              <el-button @click="queryBtnClick" type="primary" size="small"
                >查询</el-button
              >
              <el-button @click="resetFilter" type="primary" plain size="small"
                >重置</el-button
              >
              <span class="pullupbtn" @click="pullup"
                >收起<i class="el-icon-arrow-up"></i
              ></span>
            </el-row>
          </div>
        </el-tab-pane>
      </el-tabs>
    </div>

    <div class="chart-wrap">
      <div class="chart-left">
        <el-tabs value="first" class="product_management_box">
          <el-tab-pane label="按区划统计" name="first">
            <div class="btn-wrap">
              <el-button type="primary" plain size="small" @click="goFilterChart(1)" :class="{'active':btnChange == 1}">所有</el-button>
              <el-button type="primary" plain size="small" @click="goFilterChart(2)" :class="{'active':btnChange == 2}">家庭农场</el-button>
              <el-button type="primary" plain size="small" @click="goFilterChart(3)" :class="{'active':btnChange == 3}">合作社</el-button>
              <el-button type="primary" plain size="small" @click="goFilterChart(4)" :class="{'active':btnChange == 4}">示范社</el-button>
              <el-button type="primary" plain size="small" @click="goFilterChart(5)" :class="{'active':btnChange == 5}">示范家庭农场</el-button>
            </div>
            <div class="chart" id="chart_gjtj_c"></div>
          </el-tab-pane>
        </el-tabs>
      </div>

      <div class="chart-right">
        <el-tabs value="first" class="product_management_box">
          <el-tab-pane label="按项目统计" name="first">
            <div class="project-wrap">
              <div class="project-item">
                <div>
                  <div class="word-gray">项目适用区域</div>
                  <div class="strong-word">{{ qhmc }}</div>
                </div>
                <i class="el-icon-location-information font-icon"></i>
              </div>

              <div class="project-item">
                <div>
                  <div class="word-gray">发布文件</div>
                  <div class="strong-word">{{ projectJson.informationSum }} 个</div>
                </div>
                <i class="el-icon-document font-icon"></i>
              </div>

              <div class="project-item">
                <div>
                  <div class="word-gray">发布项目</div>
                  <div class="strong-word">{{ projectJson.configSum }} 个</div>
                </div>
                <i class="el-icon-coordinate font-icon"></i>
              </div>

              <div class="project-item">
                <div>
                  <div class="word-gray">参与主体数量</div>
                  <div class="strong-word">{{ projectJson.enterpriseSum }} 家</div>
                </div>
                <i class="el-icon-user font-icon"></i>
              </div>
            </div>
            <div class="project-table-wrap">
              <el-table
                :data="projectData"
                style="width: 100%"
                ref="dataTable"
                height="100%"
                highlight-current-row
              >
                <el-table-column
                  type="index"
                  align="center"
                  label="序号"
                  width="80"
                ></el-table-column>
                <el-table-column
                  prop="qhmc"
                  label="区域"
                  :formatter="formatterFn"
                >
                </el-table-column>
                <el-table-column
                  prop="informationCount"
                  label="适用文件（个）"
                  :formatter="formatterFn"
                >
                </el-table-column>
                <el-table-column
                  prop="configCount"
                  label="适用项目"
                  :formatter="formatterFn"
                >
                </el-table-column>
                <el-table-column
                  prop="enterpriseCount"
                  label="参与主体数量（家）"
                  :formatter="formatterFn"
                >
                </el-table-column>
              </el-table>
            </div>
          </el-tab-pane>
        </el-tabs>
      </div>
    </div>

    <div class="table-wrap">
      <el-tabs value="first" class="product_management_box">
        <el-tab-pane label="明细表" name="first">
          <el-row class="count_content">
            <i class="el-icon-success icon-table-summary"></i>
            <span
              >共查询到
              <span class="count_number">{{ totalItems }}</span> 条数据</span
            >
            <div
              style="display: inline-block; float: right; padding-right: 10px"
            >
              <el-button type="primary" size="small" @click="exportData" :disabled="!pjTableData.length">导出统计表</el-button
              >
            </div>
          </el-row>
          <div class="table-content">
            <el-table
            class="product_tab_1_table"
            :data="pjTableData"
            style="width: 100%"
            ref="dataTable"
            height="100%"
            highlight-current-row>
            <el-table-column
              type="index"
              align="center"
              label="序号"
              width="80"
            ></el-table-column>
            <el-table-column
              prop="titile"
              label="发布标题"
              :formatter="formatterFn"
            >
            </el-table-column>
            <el-table-column
              prop="pjConfigName"
              label="项目名称"
              :formatter="formatterFn"
            >
            </el-table-column>
            <el-table-column
              prop="enterpriseName"
              label="主体名称"
              :formatter="formatterFn"
            >
            </el-table-column>
            <el-table-column
              prop="enterpriseTypeName"
              label="主体类型"
              :formatter="formatterFn"
            >
            </el-table-column>
            <el-table-column
              prop="qhmc"
              label="区域"
              :formatter="formatterFn"
            >
            </el-table-column>
            <el-table-column
              prop="commitTime"
              label="上报时间"
              :formatter="formatterFn"
            >
            </el-table-column>
            <el-table-column label="操作" width="200" align="center">
              <template slot-scope="scope">
                <el-tooltip class="item" content="详情" placement="top">
                  <i
                    class="table-icon el-icon-document"
                    @click="searchDialog(scope.row)"
                  ></i>
                </el-tooltip>
              </template>
            </el-table-column>
          </el-table>

           <!--分页工具-->
            <el-row class="page-row">
              <el-pagination
                background
                :page-size="pageSize"
                :current-page.sync="currentPage"
                @current-change="currentChange"
                layout="prev, pager, next, jumper"
                :total="totalItems"
              >
              </el-pagination>
            </el-row>
            <detail-dialog
              :ifAudit="false"
              ref="show_operator_dialog"
            ></detail-dialog>
          </div>
        </el-tab-pane>
      </el-tabs>
    </div>
  </div>
</template>

<script>
  import Cookies from "js-cookie";
  import API from "@/api/api_project/api_project";
  import detailDialog from "../manage/detailDialog.vue"

  export default {
    name: "publishList",
    components:{
      detailDialog
    },
    created() {
      this.init()
    },
    beforeDestroy() {
      this.destroy_chart()
    },
    data() {
      return {
        btnChange: 1,
        titleName: '',
        qhdmValue: Cookies.get("curAreaCode"), // 区域
        changeQhdm: '',
        qhmc: Cookies.get("curAreaName"),
        showQueryFilter: true /*是否显示搜索条件*/,
        filterForm: {
          pjInformationId: "",
          pjConfigId: '',
          startTime: '',
          endTime: ''
        },
        projectJson: {
          informationSum: 0,
          configSum: 0,
          enterpriseSum: 0
        },
        enterpriseTypeNumber: '',
        enterpriseGradeNumber: '',
        xAxis_arr: [],
        data_arr: [],
        titleList: [],
        pjConfigList: [],
        projectData: [],
        pjTableData: [],
        currentPage: 1 /*分页工具当前选中页*/,
        pageSize: 10,
        totalItems: 0 /*数据总条数*/,
      };
    },
    methods: {
      init() {
        this.getTitleListApi()
        this.getChartList()
        this.getProjectList()
      },

      searchDialog(row) {
        this.$refs.show_operator_dialog.dialogOpen(row);
      },

      // 文件接口
      async getTitleListApi() {
        const { code, data } = await API.getTitleList({
          qhdm: this.qhdmValue
        });
        if (code === 0) {
          this.titleList = data.list;
        }
      },

      titleChange(val) {
        if(val) {
          this.getConfigListApi()
          this.filterForm.pjConfigId = ''
        }
      },

      // 文件接口
      async getConfigListApi() {
        const { code, data } = await API.getConfigList({
          pjInformationId: this.filterForm.pjInformationId
        });
        if (code === 0) {
          this.pjConfigList = data.list;
        }
      },

      /*收起按钮*/
      pullup() {
        this.showQueryFilter = false
      },

      /*展开按钮*/
      pulldown() {
        this.showQueryFilter = true
      },

      /*点击查询按钮*/
      queryBtnClick() {
        this.getChartList()
        this.getProjectList()
        this.pjTableData = []
      },

      goFilterChart(type) {
        this.btnChange = type
        switch (type) {
          case 1:
            this.enterpriseTypeNumber = ''
            this.enterpriseGradeNumber = ''
            break;

          case 2:
            this.enterpriseTypeNumber = '3003'
            this.enterpriseGradeNumber = ''
            break;

          case 3:
            this.enterpriseTypeNumber = '3001'
            this.enterpriseGradeNumber = ''
            break;

          case 4:
            this.enterpriseTypeNumber = '3001'
            this.enterpriseGradeNumber = 1
            break;

          case 5:
            this.enterpriseTypeNumber = '3003'
            this.enterpriseGradeNumber = 1
            break;

          default:
            this.enterpriseTypeNumber = ''
            this.enterpriseGradeNumber = ''
            break;
        }

        this.getChartList()
      },

      resetFilter() {
        this.filterForm = {
          pjInformationId: "",
          pjConfigId: '',
          startTime: '',
          endTime: ''
        },
        this.enterpriseTypeNumber = ''
        this.enterpriseGradeNumber = ''
        this.currentPage = 1
        this.pjTableData = []
        this.totalItems = 0

        this.queryBtnClick()
      },

      async exportData() {
        try {
          let res = await API.getRecordExport({
            pjInformationId: this.filterForm.pjInformationId,
            pjConfigId: this.filterForm.pjConfigId,
            qhdm: this.changeQhdm,
            beginTime: this.filterForm.startTime,
            endTime: this.filterForm.endTime,
            enterpriseTypeNumber: this.enterpriseTypeNumber,
            enterpriseGradeNumber: this.enterpriseGradeNumber,
          })

          if(res){
            this.GLOBAL.downloadBlobFile(res,'项目参与情况明细表', "xls", 'project')
          } else{
            console.log(res.msg || '导出数据错误')
          }
        } catch (error) {
          console.log(error || '导出数据异常')
        }
      },

      async getChartList() {
        try {
          let res = await API.getRecordCount({
            pjInformationId: this.filterForm.pjInformationId,
            pjConfigId: this.filterForm.pjConfigId,
            qhdm: this.qhdmValue,
            beginTime: this.filterForm.startTime,
            endTime: this.filterForm.endTime,
            enterpriseTypeNumber: this.enterpriseTypeNumber,
            enterpriseGradeNumber: this.enterpriseGradeNumber,
          })

          if (res.code == 0) {
            let xAxis_arr = []
            let data_arr = []

            res.data.list.forEach(item =>{
              xAxis_arr.push(item.qhmc)
              data_arr.push(item.recordCount)
            })

            /*x轴*/
            this.xAxis_arr = xAxis_arr
            /*业务数据*/
            this.data_arr = data_arr

            this.init_chart(res.data.list);

            } else {
            this.destroy_chart()
            console.log(res.msg || '查询数据错误')
          }
        } catch (error) {
          this.destroy_chart()
          console.log(error || '查询数据异常')
        }

      },

      async getTableList() {
        try {
          let res = await API.getRecordList({
            pjInformationId: this.filterForm.pjInformationId,
            pjConfigId: this.filterForm.pjConfigId,
            qhdm: this.changeQhdm,
            beginTime: this.filterForm.startTime,
            endTime: this.filterForm.endTime,
            page: this.currentPage,
            pageSize: this.pageSize,
            enterpriseTypeNumber: this.enterpriseTypeNumber,
            enterpriseGradeNumber: this.enterpriseGradeNumber,
          })

          if (res.code == 0) {
            this.totalItems = res.data.count
            this.pjTableData = res.data.list || []
          } else {
            console.log(res.msg || '查询数据错误')
          }
        } catch (error) {
          console.log(error || '查询数据异常')
        }
      },

      async getProjectList() {
        try {
          let res = await API.getProjectList({
            pjInformationId: this.filterForm.pjInformationId,
            pjConfigId: this.filterForm.pjConfigId,
            qhdm: this.qhdmValue,
            beginTime: this.filterForm.startTime,
            endTime: this.filterForm.endTime,
          })

          if (res.code == 0) {
            this.projectJson = res.data
            this.projectData = res.data.list || []
          } else {
            console.log(res.msg || '查询数据错误')
          }
        } catch (error) {
          console.log(error || '查询数据异常')
        }
      },

      formatterFn(row, column, cellValue, index) {
        if (!cellValue && cellValue !== 0) {
          return '--';
        }
        return cellValue;
      },

      init_chart(list) {
        let _that = this

        if (this.myEcharts) {
          this.myEcharts.dispose(document.getElementById('chart_gjtj_c'))
        }

        let dom = document.getElementById('chart_gjtj_c');
        this.myEcharts = this.$echarts.init(dom);

        let option = this.getOptions();
        this.myEcharts.setOption(option, true);

        this.myEcharts.on('click', function (params) {
          if(params.name && list && list.length) {
            let temp = list.filter((item) => item.qhmc == params.name)

            if (temp) {
              _that.changeQhdm = temp[0].qhdm
              _that.getTableList()
            }
          }
        })
        setTimeout(() => {
          this.resize();
        }, 200)
      },

      getOptions() {
        /*x轴*/
        let xAxis_arr = this.xAxis_arr
        /*业务*/
        let data_arr = this.data_arr

        let max_value = 0/*最大值*/
        let max_value_arr = []/*最大值数组*/
        let bottom_data_arr =[] /*最小*/
        data_arr.forEach(item => {
          if(item > max_value){max_value =  item}
          bottom_data_arr.push(0)
        })
        max_value = max_value
        data_arr.forEach(item => {max_value_arr.push(max_value)})

        /*是否显示zoom*/
        let isZoom = true
        if(data_arr.length <= 3){
          isZoom = false
        }

        return  {
          backgroundColor: '#fff',
          color: [
            '#e7faf4',
            '#0dc98e',
          ],
          grid: {
            // show: true
            containLabel: false,
            left: 35,
            right: 10,
            bottom:50,
            top:30,
          },
          dataZoom: [
            // 前面显示
            {
              show: true,
              type: 'slider',
              height: '6px',
              width: '95%',
              startValue: 0,
              endValue: 5,
              bottom: 30,
              fillerColor: 'rgba(15,97,131,0.3)',
              backgroundColor: '#e7faf4',
              textStyle: {
                color: "#535353"
              },
              borderColor: "#e7faf4",
            },
          ],
          xAxis: {
            axisLabel: {
              color: '#535353',
              fontSize: 12,
              interval: 0,
            },
            axisTick: {
              lineStyle: {
                color: '#f0f0f0',
              },
              show: true,
            },
            splitLine: {
              show: false,
            },
            axisLine: {
              lineStyle: {
                color: '#f0f0f0',
                width: 1,
                type: 'dashed',
              },
              show: true,
            },
            data: xAxis_arr,
            type: 'category',
          },
          yAxis: {
            name: '家',
            nameTextStyle: {
              color: '#535353'
            },
            min: 'dataMin',
            max: 'dataMax',
            axisLabel: {
              color: '#535353',
              fontSize: 12,
            },
            boundaryGap: ['20%', '20%'],
            axisTick: {
              lineStyle: {
                color: '#f0f0f0',
                width: 1,
              },
              show: true,
            },
            splitLine: {
              show: true,
              lineStyle: {
                color: '#f0f0f0',
                type: 'dashed',
              },
            },
            axisLine: {
              lineStyle: {
                color: '#f0f0f0',
                width: 1,
                type: 'dashed',
              },
              show: true,
            },
          },
          series: [
            {
              data: data_arr,
              type: 'bar',
              //barMaxWidth: '30',
              barWidth: 20,
              itemStyle: {
                color: {
                  x: 0,
                  y: 0,
                  x2: 0,
                  y2: 1,
                  type: 'linear',
                  global: false,
                  colorStops: [
                    {
                      offset: 1,
                      color: '#9ee9d2',
                    },
                    {
                      offset: 0,
                      color: '#0EAC79',
                    },
                  ],
                },
              },
              label: {
                show: true,
                position: 'top',
                distance: 5,
                color: '#0EAC79',
              },
            },
            {
              data: bottom_data_arr,
              type: 'pictorialBar',
              /*barMaxWidth: '20',*/
              barWidth: 20,
              symbol: 'diamond',
              symbolOffset: [0, '50%'],
              symbolSize: [20, 15],
            },
            {
              data: data_arr,
              type: 'pictorialBar',
              /*barMaxWidth: '20',*/
              barWidth: 20,
              symbolPosition: 'end',
              symbol: 'diamond',
              symbolOffset: [0, '-50%'],
              symbolSize: [20, 12],
              zlevel: 2,
            },
            {
              data: max_value_arr,
              type: 'bar',
              /*barMaxWidth: 'auto',*/
              barWidth: 20,
              barGap: '-100%',
              zlevel: -1,
            },
            {
              data: bottom_data_arr,
              type: 'pictorialBar',
              /*barMaxWidth: '20',*/
              barWidth: 20,
              symbol: 'diamond',
              symbolOffset: [0, '50%'],
              symbolSize: [20, 15],
              zlevel: -2,
            },
            {
              data: max_value_arr,
              type: 'pictorialBar',
              /*barMaxWidth: '20',*/
              barWidth: 20,
              symbolPosition: 'end',
              symbol: 'diamond',
              symbolOffset: [0, '-50%'],
              symbolSize: [20, 12],
              zlevel: -1,
            },
          ],
          tooltip: {
            trigger: 'axis',
            show: false,
          },
        };
      },

      resize() {
        if (this.myEcharts) {
          this.$nextTick(() => {
            this.myEcharts.resize();
          })
        }
      },

      destroy_chart() {
        if (this.myEcharts) {
          this.$nextTick(() => {
            this.myEcharts.dispose();
            this.myEcharts = ''
          })
        }
      },
      /*分页工具换页*/
      currentChange(val) {
        this.currentPage = val;
        this.getTableList();
      },
    }
  }
</script>
<style lang="less" scoped>
@tableColor: #F8f8f8; /*table表头背景色*/
@blueColor: #E6A23C; /*收起展开按钮颜色*/
@themeColor: #0dc98e;

  .wrap {
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    .el-tabs__content .el-tab-pane .expandbox {
      padding-bottom: 0 !important;
    }

    .el-tabs__content .el-tab-pane .info-container {
      margin-top: 0 !important;
    }

    .el-form-item--small.el-form-item {
      margin-bottom: 0 !important;
    }
  }

  .table-content {
    height: calc(100% - 100px);
  }

  .chart-wrap {
    height: 36%;
    display: flex;
    margin-top: 8px;
    justify-content: space-around;

    .chart-left, .chart-right {
      width: 50%;
    }
  }

  .btn-wrap {
    display: flex;
    justify-content: space-around;
    // width: 65%;
    height: 30px;
    float: right;
    margin: 10px 0;
  }

  /*收起按钮*/
  .pullupbtn {
    position: relative;
    bottom: -7px;
    margin-left: 10px;
    font-size: 12px;
    color: #E6A23C;
    &:hover {
      cursor: pointer;
      color: #E6A23C;
    }
  }

  .textInput {
    width :200px;
    height: 40px;
  }

  /*展开按钮*/
  .pulldownbox {
    height: 30px;
    width: 100%;

    .pulldownbtn {
      position: relative;
      bottom: 0px;
      margin-left: 10px;
      font-size: 12px;
      color: @blueColor;
      &:hover {
        cursor: pointer;
        color: #78BFF1;
      }
    }
  }

  .project-table-wrap {
    height: calc(100% - 80px);
  }

  .project-wrap {
    display: flex;
    height: 70px;
    margin: 0;
    justify-content: space-around;
  }

  .project-item {
    background: #fff;
    border: 1px solid #f0f0f0;
    width: 24%;
    display: flex;
    align-items: center;
    // margin-right: 12px;
    padding: 0 12px;
    justify-content: space-between;
  }

  .chart {
    width: 100%;
    height: calc(100% - 32px);
    clear: both;
  }

  .font-icon {
    font-size: 24px;
    color: #0EAC79;
  }

  .word-gray {
    color: gray;
  }

  .strong-word {
    color: #535353;
    font-weight: bold;
  }

  .table-wrap {
    flex-grow: 1;
  }

  .product_management_box .el-tabs__content .el-tab-pane .expandbox {
    padding-bottom: 10px;
  }

  .page-row {
    // height: 60px;
    width: 100%;
    text-align: center;
    // padding-top:10px;
    box-sizing: border-box;
  }

  .count_number{
    color: @themeColor;
  }

  .active {
    background: @themeColor !important;
    color: #e7faf4 !important;
  }
</style>



// WEBPACK FOOTER //
// src/studio/projectStatistics/publishList.vue